/**
 * Provides the configuration for the application's error handler.
 *
 * This configuration is based on the `ErrorHandlerConfig` interface and integrates
 * the predefined application error messages stored in the `APP_ERRORS` constant.
 * It ensures a centralized and consistent way to handle and display error messages
 * across the application.
 *
 * @see ErrorHandlerConfig - Interface defining the structure of the error handler configuration.
 * @see APP_ERRORS - Constant containing the mapping of error keys to their corresponding messages.
 */
import { ErrorHandlerConfig } from '@errorHandler';
import { APP_ERRORS } from '../constants/errors.constants';
import { DEBUG_MODE } from './debug.config';

export const APP_ERROR_HANDLER_CONFIG: ErrorHandlerConfig = {
  errors: APP_ERRORS,
  debug: DEBUG_MODE,
};
